import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { MeResult } from "@/integrations/api/auth";

interface AuthState {
  user: MeResult["user"] | null;
  profile: MeResult["profile"] | null;
  roles: MeResult["roles"];
  branches: MeResult["branches"];
  hod_department_ids: string[];
  hodDepartmentIds: string[];   // camelCase alias — used by components
  isAuthenticated: boolean;
  must_change_password: boolean;
  
  setAuth: (data: MeResult) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      profile: null,
      roles: [],
      branches: [],
      hod_department_ids: [],
      hodDepartmentIds: [],
      isAuthenticated: false,
      must_change_password: false,

      setAuth: (data) => set({
        user: data.user,
        profile: data.profile,
        roles: data.roles,
        branches: data.branches,
        hod_department_ids: data.hod_department_ids,
        hodDepartmentIds: data.hodDepartmentIds ?? data.hod_department_ids ?? [],
        must_change_password: data.must_change_password ?? false,
        isAuthenticated: true,
      }),

      clearAuth: () => set({
        user: null,
        profile: null,
        roles: [],
        branches: [],
        hod_department_ids: [],
        hodDepartmentIds: [],
        isAuthenticated: false,
        must_change_password: false,
      }),
    }),
    {
      name: "hams-auth-storage",
    }
  )
);
